import StyledLink from '../StyledLink'
import {
  DESIGNER,
  EDIT,
  SCRIPTED,
  TESTCASES
} from '../routes'
import type { Props } from '../types'

interface Params {
  testCaseId: string
}

const LinkToScriptedTestCaseEdit = ({
  children,
  testCaseId,
  isHyperlink,
  label,
  openInNewTab
}: Props & Params) =>
  <StyledLink
    aria-label={label}
    isHyperlink={isHyperlink}
    openInNewTab={openInNewTab}
    to={`/${DESIGNER}/${TESTCASES}/${SCRIPTED}/${testCaseId}/${EDIT}`}
  >
    {children}
  </StyledLink>

export default LinkToScriptedTestCaseEdit
